import { Tag } from "antd";
import React from "react";

const CommonAmountPage = ({ amountData }) => {
  return (
    <>
      <div className="flex gap-3">
        <div className="bg-primary text-white px-4 py-2 rounded">
          Total ₹ {""}
          {amountData?.total_amount ?? "0"}
        </div>
        <div className="border border-green-500 text-green-600 px-4 py-2 rounded">
          Success ₹ {""}
          {amountData?.success_amount ?? "0"}
        </div>
        <div className="border border-red-500 text-red-600 px-4 py-2 rounded">
          Failed ₹ {""}
          {amountData?.failed_amount ?? "0"}
        </div>
        <div className="border border-orange-500 text-orange-600 px-4 py-2 rounded">
          Pending ₹ {""}
          {amountData?.pending_amount ?? "0"}
        </div>
      </div>
    </>
  );
};

export default CommonAmountPage;
